import {
  sendMessage as sendMessageRepository,
  receiveMessage as receiveMessageRepository,
  receiveEmoji as receiveEmojiRepository,
  getMessages,
  postSharePub,
  reportMessage,
  saveReaction,
  archiveChat,
  deleteChat,
  searchFriend,
} from "../repositories/ChatRepository";
import { chatMapper } from "../mappers/ChatMapper";

export const sendMessageService = async (sendMsg) => {
  try {
    const result = await sendMessageRepository(sendMsg);

    return result;
  } catch (error) {
    console.error("[ChatService] Error en sendMessageService:", error);
    throw error;
  }
};

export const receiveMessageService = async (sendMsg) => {
  try {
    const messages = await receiveMessageRepository(sendMsg);
    return chatMapper(messages, sendMsg);
  } catch (error) {
    throw error;
  }
};

export const receiveEmojiService = async () => {
  try {
    return await receiveEmojiRepository();
  } catch (error) {
    throw error;
  }
};

export const receiveMessagesService = async (IdUsuario, IdAmigo) => {
  try {
    return await getMessages(IdUsuario, IdAmigo);
  } catch (error) {
    throw error;
  }
};

export const fetchConversationHistoryService = receiveMessagesService;

export const postSharePubService = async (req) => {
  try {
    return await postSharePub(req);
  } catch (error) {
    throw error;
  }
};

// Reportar mensaje
export const reportMessageService = async (req) => {
  try {
    return await reportMessage(req);
  } catch (error) {
    throw error;
  }
};

// Insertar/Actualizar/Eliminar reacción
export const saveReactionService = async (req) => {
  try {
    return await saveReaction(req);
  } catch (error) {
    throw error;
  }
};

//Archivar Chat
export const archiveChatService = async (req) => {
  try {
    return await archiveChat(req);
  } catch (error) {
    throw error;
  }
};

//Eliminar Chat

export const deleteChatService = async (req) => {
  try {
    return await deleteChat(req);
  } catch (error) {
    throw error;
  }
};

// Buscar amigo

export const searchFriendRepository = async (req) => {
  try {
    return await searchFriend(req);
  } catch (error) {
    throw error;
  }
};
